import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Transition, { ENTERED, ENTERING, EXITED, EXITING } from 'react-transition-group/Transition';
import TransitionGroup from 'react-transition-group/TransitionGroup';

import { hoverDefault, toVw, verticalAlign, verticalAlignWrapper } from '../utils/styles';

const modalRoot = document.getElementById('modal-root');

const ANIMATION_DURATION = 300;

const s = {
  [ENTERING]: {
    opacity: 0,
  },
  [ENTERED]: {
    opacity: 1,
  },
  [EXITING]: {
    opacity: 0,
  },
  [EXITED]: {
    opacity: 0,
  },
};

const Styled = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.9);
  text-align: center;
  z-index: 1;
  color: ${props => props.theme.colorMinor};
  ${verticalAlignWrapper};
  opacity: ${({ state, constant }) => (constant ? 1 : s[state].opacity)};
  transition: opacity ${ANIMATION_DURATION}ms ease-out;
`;

const Content = styled.div`
  ${verticalAlign};
`;

const Plus = styled.div`
  position: relative;
  height: ${toVw(80)};
  width: ${toVw(80)};
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${toVw(80)};

  &:before,
  &:after {
    content: '';
    display: block;
    position: absolute;
    background-color: #fff;
  }

  &:before {
    left: 50%;
    margin-left: ${toVw(-2)};
    height: 100%;
    width: ${toVw(4)};
  }

  &:after {
    top: 50%;
    margin-top: ${toVw(-2)};
    width: 100%;
    height: ${toVw(4)};
  }
`;

const Text = styled.div``;

const Close = styled.div`
  position: absolute;
  bottom: 10vh;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  ${hoverDefault};
`;

class UploadScreen extends React.PureComponent {
  render() {
    const { children, onCloseClick, shown } = this.props;

    return (
      <TransitionGroup>
        {shown && (
          <Transition appear timeout={ANIMATION_DURATION}>
            {state =>
              ReactDOM.createPortal(
                <Styled state={state}>
                  <Content>
                    <Plus />
                    <Text>
                      Drag and drop here
                      <br />
                      or choose file
                    </Text>
                  </Content>
                  {children}
                  <Close onClick={onCloseClick}>close</Close>
                </Styled>,
                modalRoot
              )
            }
          </Transition>
        )}
      </TransitionGroup>
    );
  }
}

UploadScreen.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  shown: PropTypes.bool.isRequired,
};

export default UploadScreen;



// WEBPACK FOOTER //
// ./src/components/UploadScreen.js